import { WidgetCard } from './WidgetCard';
import { MOCK_CASE_STAGES, totalCases } from '../mocks/cases';

const STAGE_TAPER = [1, 0.75, 0.55, 0.4];

const stageGradients: Record<string, string> = {
  New: 'linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%)',
  'In Review': 'linear-gradient(90deg, #8b5cf6 0%, #a78bfa 100%)',
  Escalated: 'linear-gradient(90deg, #ef4444 0%, #f87171 100%)',
  Resolved: 'linear-gradient(90deg, #22c55e 0%, #4ade80 100%)',
};

const stageShadows: Record<string, string> = {
  New: '0 4px 14px rgba(59, 130, 246, 0.35)',
  'In Review': '0 4px 14px rgba(139, 92, 246, 0.35)',
  Escalated: '0 4px 14px rgba(239, 68, 68, 0.35)',
  Resolved: '0 4px 14px rgba(34, 197, 94, 0.35)',
};

export function CaseStatusFunnelWidget() {
  const total = totalCases(MOCK_CASE_STAGES);
  const maxCount = Math.max(...MOCK_CASE_STAGES.map((s) => s.count));

  return (
    <WidgetCard title="Case Status Funnel">
      <div className="flex flex-col gap-3">
        {MOCK_CASE_STAGES.map((stage, index) => {
          const percentage = total > 0 ? Math.round((stage.count / total) * 100) : 0;
          // Visual funnel: each stage is a fixed ratio narrower than the previous,
          // while the text still shows the real count and percentage.
          const widthPercent = maxCount > 0 ? STAGE_TAPER[index] * 100 : 0;

          return (
            <div key={stage.stage} className="group">
              <div className="mb-1 flex items-center justify-between text-sm">
                <span className="font-medium text-gray-900">{stage.stage}</span>
                <span className="text-gray-500">
                  {stage.count} ({percentage}%)
                </span>
              </div>
              <div className="h-10 w-full overflow-hidden rounded-lg bg-gray-100">
                <div
                  className="animate-funnel-grow flex h-full items-center justify-end rounded-lg px-3 text-sm font-semibold text-white transition-[filter,transform] duration-300 ease-out group-hover:scale-[1.02] group-hover:brightness-110"
                  style={{
                    width: `${widthPercent}%`,
                    background: stageGradients[stage.stage],
                    boxShadow: stageShadows[stage.stage],
                    minWidth: '3rem',
                    animationDelay: `${index * 120}ms`,
                  }}
                >
                  <span className="drop-shadow-md">{stage.count}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3 text-sm">
        <span className="text-gray-500">Total cases</span>
        <span className="font-semibold text-gray-900">{total}</span>
      </div>
    </WidgetCard>
  );
}
